import { useTranslation } from "react-i18next";
import { applyUpdate, useUpdateAvailable } from "./update";

/** A new version of the app is ready. It is taken into use when the person chooses, never by force. */
export default function UpdatePrompt() {
  const { t } = useTranslation();
  if (!useUpdateAvailable()) return null;
  return (
    <div role="status" className="flex flex-wrap items-center justify-center gap-3 bg-sea-100 px-4 py-2 text-sm text-sea-900">
      <span>{t("logbook.offline.newVersion")}</span>
      <button className="btn btn-primary" onClick={applyUpdate}>
        {t("logbook.offline.update")}
      </button>
    </div>
  );
}
